"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCoherent = isCoherent;
function isCoherent(boatName) {
    if (boatName && boatName.includes('instanda')) {
        return false;
    }
    return true;
}
;
